/* eslint-disable max-len */
/* eslint-disable no-empty */
import CartServer from '../../server/cart';
import StorageService from '../../services/storage';
import tagManager from '../../services/tagManager';
import CartUtil from '../../utils/cart';
import { getUser } from './auth';
import { addLoading, removeLoading } from './loading';

export const setItems = (items, cartId, user) => ({
  type: 'CART_SET_ITEMS',
  items,
  cartId,
  user,
});

export const setObservation = observationText => ({
  type: 'CART_SET_OBSERVATION',
  observationText,
});

export const setDeliveryAddress = deliveryAddress => ({
  type: 'CART_SET_DELIVERY_ADDRESS',
  deliveryAddress,
});

export const setFreight = freight => ({
  type: 'CART_SET_FREIGHT',
  freight,
});

export const setFreightGKO = freight => ({
  type: 'CART_SET_FREIGHT_GKO',
  freight,
});

export const cartSetClientNumber = clientNumber => ({
  type: 'CART_SET_CLIENT_NUMBER',
  clientNumber,
});

export const cartSetMinimumBillingDate = minimumBillingDate => ({
  type: 'CAR_SET_MINIMUM_BILLING_DATE',
  minimumBillingDate,
});

export const cartSortItems = value => ({
  type: 'CART_SET_ORDER_BY',
  value,
});

export const cartSetManagerEmail = managerEmail => ({
  type: 'CART_SET_MANAGER_EMAIL',
  managerEmail,
});

export const cartSetResponsibleReceiving = responsibleReceiving => ({
  type: 'CART_SET_RESPONSIBLE_RECEIVING',
  responsibleReceiving,
});

export const cartSetDeliverySector = deliverySector => ({
  type: 'CART_SET_DELIVERY_SECTOR',
  deliverySector,
});

const addCartItemsIndexes = (items) => {
  items.forEach((item, index) => {
    item.index = index;
  });
};

export const getCart = () => async (dispatch, getState) => {
  const { cartPermission } = getState().contracts.selected;

  if (!cartPermission) return;

  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;

  // dispatch(cartActiveLoading());

  const items = await CartServer.getCart(clientId, punchoutUserId);

  addCartItemsIndexes(items);
  dispatch(setItems(items));
};

export const getCartCache = () => async (dispatch) => {
  try {
    const cartItems = StorageService.get('user_cart_cached') || [];

    addCartItemsIndexes(cartItems);
    dispatch(setItems(cartItems));
  } finally {}
};

export const cartAddItem = (productId, productClientCode, total = 1, doLoading = true, isItemCache = false, productCode, mandatoryQuantity = '') => async (dispatch, getState) => {
  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const { cartId, user } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;
  if (doLoading) dispatch(addLoading());

  try {
    const tagTotal = total;
    const item = getState().cart.items
      .find(i => i.product.id === productId && i.product.clientCode === productClientCode);
    if (item) total += item.total;
    const searchIdSonepar = StorageService.get('search_id_sonepar');
    const quantityMandatoryQuantity = (item) ? mandatoryQuantity += (item.mandatoryQuantity || 0) : mandatoryQuantity;

    const items = await CartServer.updateCart(
      clientId, cartId, productId, productClientCode,
      total, punchoutUserId, undefined, isItemCache,
      productCode, quantityMandatoryQuantity, searchIdSonepar,
    );
    addCartItemsIndexes(items);

    const itemToTag = items.find(it => it.id === productId);

    dispatch(setItems(items, cartId, user));

    if (itemToTag) {
      tagManager.addProductToCart({
        name: itemToTag.name,
        price: itemToTag.price ? (itemToTag.price.value || 0) : 0,
        quantity: tagTotal,
        mandatoryQuantity: quantityMandatoryQuantity,
      });

      tagManager.ecommerceAddProductToCart([{
        name: itemToTag.name,
        id: itemToTag.code,
        price: `${itemToTag.price ? (itemToTag.price.value || 0) : 0}`,
        brand: itemToTag.brand ? itemToTag.brand.description : '',
        category: itemToTag.category ? itemToTag.category.name : '',
        quantity: tagTotal,
        mandatoryQuantity: quantityMandatoryQuantity,
      }]);
    }
  } finally {
    if (doLoading) dispatch(removeLoading());
  }
};

export const cartAddItemCache = (productId, total = 1, mandatoryQuantity) => async (dispatch) => {
  try {
    total = parseInt(total, 10);
    dispatch(addLoading());
    const cartItems = StorageService.get('user_cart_cached') || [];
    const item = cartItems
      .find(i => i.id === productId);
    if (item) {
      item.quantity += total;
      item.mandatoryQuantity = (item.mandatoryQuantity) ? item.bidSize + mandatoryQuantity : mandatoryQuantity;
    } else {
      const itemInfo = await CartServer.getCartInformation(productId);

      if (itemInfo && itemInfo[0]) {
        itemInfo[0].quantity = total;
        itemInfo[0].mandatoryQuantity = mandatoryQuantity;
        cartItems.push(itemInfo[0]);
      }
    }

    addCartItemsIndexes(cartItems);
    dispatch(setItems(cartItems));
    StorageService.set('user_cart_cached', cartItems);
  } finally {
    dispatch(removeLoading());
  }
};

export const cartUpdateItem = (productId, productClientCode, total = 1, xped = '', showLoading = true, mandatoryQuantity) => async (dispatch, getState) => {
  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const { cartId, user } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;
  if (showLoading) dispatch(addLoading());

  try {
    const items = await CartServer.updateCart(clientId,
      cartId, productId, productClientCode, total, punchoutUserId, xped, undefined, undefined, mandatoryQuantity);
    addCartItemsIndexes(items);
    dispatch(setItems(items, cartId, user));
  } finally {
    if (showLoading) dispatch(removeLoading());
  }
};

export const getFreight = () => async (dispatch, getState) => {
  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const { cartId } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;
  dispatch(setFreight(null));
  dispatch(addLoading());

  try {
    const freight = await CartServer.getFreight(clientId, cartId, punchoutUserId);
    dispatch(setFreight(freight));
  } finally {
    dispatch(removeLoading());
  }
};

export const getFreightGKO = () => async (dispatch, getState) => {
  const clientId = getState().contracts.selected
    && getState().contracts.selected.client
    && getState().contracts.selected.client.id;

  const deliveryLocation = getState().contracts.selected
    && getState().contracts.selected.client
    && getState().contracts.selected.client.locations
    && getState().contracts.selected.client.locations[0].deliveryCode;

  const location = getState().contracts
    && getState().contracts.selected
    && getState().contracts.selected.clientDetails
    && getState().contracts.selected.clientDetails.location
    && getState().contracts.selected.clientDetails.location.id;

  const { items } = getState().cart;
  const products = items.map(element => ({
    code: element.product.code,
    quantity: element.product.quantity,
    unitPriceValue: element.product.price ? element.product.price.value : null,
  }));

  dispatch(setFreightGKO(null));
  dispatch(addLoading());

  try {
    const freight = await CartServer.getFreightGKO(clientId, deliveryLocation, location, products);
    dispatch(setFreightGKO(freight));
  } finally {
    dispatch(removeLoading());
  }
};

export const cartRemoveItem = (productId, productClientCode) => async (dispatch, getState) => {
  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const { cartId, user } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;

  dispatch(addLoading());

  try {
    const itemsInCart = getState().cart.items;
    const items = await CartServer.updateCart(clientId, cartId, productId, productClientCode, 0, punchoutUserId);
    if (cartId && items.length === 0) await dispatch(getCart());
    else dispatch(setItems(items, cartId, user));

    const itemToTag = itemsInCart.find((it = {}) => {
      const { product = {} } = it;
      return product.id === productId;
    }) || {};

    if (itemToTag && itemToTag.product) {
      tagManager.ecommerceRemoveProductToCart([{
        name: itemToTag.product.name,
        id: itemToTag.product.code,
        price: `${itemToTag.product.price ? (itemToTag.product.price.value || 0) : 0}`,
        brand: itemToTag.product.brand ? itemToTag.product.brand.description : '',
        category: itemToTag.product.category ? itemToTag.product.category.name : '',
        quantity: itemToTag.product.quantity,
      }]);
    }
  } finally {
    dispatch(removeLoading());
  }
};

export const cartRemoveItemCache = productId => async (dispatch) => {
  try {
    const cartItems = StorageService.get('user_cart_cached') || [];
    const itemIndex = cartItems
      .findIndex(i => i.id === productId);
    if (itemIndex !== -1) {
      cartItems.splice(itemIndex, 1);
    }

    addCartItemsIndexes(cartItems);
    dispatch(setItems(cartItems));
    StorageService.set('user_cart_cached', cartItems);
  } finally {}
};

export const mergeCart = () => async (dispatch, getState) => {
  try {
    const { contracts = {} } = getState();
    const { cartPermission } = contracts.selected || {};

    if (!cartPermission) {
      StorageService.set('user_cart_cached', []);
      return;
    }

    const cartItems = StorageService.get('user_cart_cached') || [];
    if (cartItems.length) {
      const promises = [];
      for (let index = 0; index < cartItems.length; index += 1) {
        const item = cartItems[index];

        promises.push(cartAddItem(item.id, undefined, item.quantity, true, true, item.code, item.mandatoryQuantity)(dispatch, getState));
      }

      await Promise.all(promises);
      StorageService.set('user_cart_cached', []);
    }
  } finally {}
};

export const cartCleanItems = () => async (dispatch, getState) => {
  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const { cartId, user } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;

  dispatch(addLoading());

  try {
    const items = await CartServer.resetCart(clientId, cartId, punchoutUserId);
    if (cartId) await dispatch(getCart());
    else dispatch(setItems(items, cartId, user));
  } finally {
    dispatch(removeLoading());
  }
};

export const cartSolicitation = () => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    const observation = getState().cart.observation ? getState().cart.observation : '';
    const company = getState().settings.companyTag;
    const punchoutScope = getState().punchOut;

    const {
      items = [], deliveryAddress, responsibleReceiving, deliverySector,
    } = getState().cart;

    const { taxType } = getState().settings;
    const actionField = {};
    const products = items.map(it => it.product || {});

    try {
      const valueItems = CartUtil.getCartTotal(items, false, taxType, undefined, company);
      actionField.revenue = `${valueItems}`;
      actionField.affiliation = 'Nortel eShop';
    } catch (e) { }

    try {
      await CartServer.cartSolicitation(
        clientId, observation, deliveryAddress, { responsibleReceiving, deliverySector }, punchoutScope,
      );

      actionField.id = '0';

      tagManager.ecommercePurchase(products, actionField);
      tagManager.onEndCheckout(items);

      dispatch(setObservation(''));
      dispatch(setItems([]));
    } catch (error) {
      throw error;
    }
  } finally {
    dispatch(removeLoading());
  }
};

export const cartsGetListToApprove = filterBy => async (dispatch, getState) => {
  let loaded = false;
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    setTimeout(() => {
      if (!loaded) dispatch(addLoading());
    }, 600);
    const carts = await CartServer.getCartsToApprove(clientId, filterBy);
    loaded = true;
    return carts;
  } finally {
    loaded = true;
    dispatch(removeLoading());
  }
};

export const cartApproveRemove = cartId => async (dispatch, getState) => {
  const { cartId: selectedCartId } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;

  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    await CartServer.removeCart(clientId, cartId, punchoutUserId);
    if (selectedCartId) dispatch(getCart());

    await dispatch(getUser());
  } finally {
    dispatch(removeLoading());
  }
};

export const cartRequesterCancelOrder = (cartId, observation, approversEmail) => async (dispatch, getState) => {
  const { cartId: selectedCartId } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;

  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    await CartServer.cartRequesterCancelOrder(clientId, cartId, punchoutUserId, observation, approversEmail);
    if (selectedCartId) dispatch(getCart());

    await dispatch(getUser());
  } finally {
    dispatch(removeLoading());
  }
};

export const cartApproveApprove = cartId => async (dispatch, getState) => {
  const { cartId: selectedCartId } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;

  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    await CartServer.approveCart(clientId, cartId, punchoutUserId);
    if (selectedCartId) dispatch(getCart());

    await dispatch(getUser());
  } finally {
    dispatch(removeLoading());
  }
};

export const cartApproveSelect = (cart, cartId, user, cartAddressInformation = {}) => async (dispatch, getState) => {
  dispatch(addLoading());

  try {
    dispatch(setItems(cart, cartId, user));

    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;

    const {
      addressCep,
      addressName,
      addressWithdraw,
      addressWithdrawLocker,
    } = cartAddressInformation;

    const deliveryAddress = await CartServer.findDeliveryAddress(
      clientId, addressCep, addressName, addressWithdraw, addressWithdrawLocker,
    );

    if (deliveryAddress) {
      dispatch(setDeliveryAddress({
        address: {
          ...deliveryAddress.address,
          isClient: Boolean(cartAddressInformation.addressWithdraw),
          isLocker: Boolean(cartAddressInformation.addressWithdrawLocker),
        },
      }));
    }
  } finally {
    dispatch(removeLoading());
  }
};

export const cartGetFile = type => async (dispatch, getState) => {
  dispatch(addLoading());
  const { cartId } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;

  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    await CartServer.getCartFile(clientId, cartId, type, punchoutUserId);
  } finally {
    dispatch(removeLoading());
  }
};

export const cartsGetSolicitationsList = () => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    const carts = await CartServer.getCartSolicitations(clientId);
    return carts;
  } finally {
    dispatch(removeLoading());
  }
};

export const cartsCopy = purchaseId => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    const punchoutUserId = getState().punchOut && getState().punchOut.userId;

    const items = await CartServer.copyCart(clientId, purchaseId, punchoutUserId);
    dispatch(setItems(items));
  } finally {
    dispatch(removeLoading());
  }
};

export const copyCartCanceled = cartId => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    const items = await CartServer.copyCartCanceled(clientId, cartId);
    dispatch(setItems(items));
  } finally {
    dispatch(removeLoading());
  }
};

export const updateDefaultAddress = (cep, nameAbbr) => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    const userId = getState().contracts.selected && getState().contracts.selected.userId;
    await CartServer.updateAddress(clientId, userId, cep, nameAbbr);
    await dispatch(getUser());
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadProductsList = file => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    const { cartId } = getState().cart;
    const result = await CartServer.uploadProductsList(cartId, clientId, file);
    return result;
  } finally {
    dispatch(removeLoading());
    dispatch(getCart());
  }
};

export const getProductListModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CartServer.getXlsxProductListModel();
  } finally {
    dispatch(removeLoading());
  }
};

export const approveCartAll = (cartsToApprove, clientId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CartServer.approveCartAll(cartsToApprove, clientId);
    await dispatch(getUser());
  } finally {
    dispatch(removeLoading());
  }
};

export const reproveCartAll = cartIds => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CartServer.reproveCartAll(cartIds);
    await dispatch(getUser());
  } finally {
    dispatch(removeLoading());
  }
};
